// eslint-disable-next-line import/prefer-default-export
export const GOOGLE_LIBS = [
    "places"
];

export const LOCATION_TYPES = {
    ADDRESS: 1,
    DORM: 2,
}
